import React, { createContext, useContext, useState } from 'react';

const AdminLoginModalContext = createContext();

export const AdminLoginModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openAdminLogin = () => setIsOpen(true);
  const closeAdminLogin = () => setIsOpen(false);

  return (
    <AdminLoginModalContext.Provider value={{ isOpen, openAdminLogin, closeAdminLogin }}>
      {children}
    </AdminLoginModalContext.Provider>
  );
};

export const useAdminLoginModal = () => useContext(AdminLoginModalContext);
